import PropTypes from 'prop-types'
import { branch, compose, getContext, withProps } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { selectCurrentCELs } from 'src/store/selectors/home/dictionary'
import { Dictionary } from 'finance'
import { sampleLoan } from 'src/constants/homePreview'
import { refiTodayKey } from 'src/constants/refinance'

const dictionary = new Dictionary(0)

const contextTypes = {
  withCurrentHomeData: PropTypes.bool,
  locked: PropTypes.bool
}

const composeWithHomeData = compose(
  connect((state, { rateType, term }) => {
    const dictionary = selectCurrentCELs(state)

    return {
      apr: dictionary.refiAPR({ rateType }),
      rate: dictionary.refiRate({ rateType }),
      savingsTotal: dictionary.refiSavingsTotal({ rateType }),
      paymentSavings: dictionary.refiPaymentSavingsMonthly({ rateType }),
      years: term === 'custom' ? dictionary.yearsLeft({ rateType }) : term
    }
  })
)

const composeWithoutHomeData = compose(
  withProps(({ rateType, term }) => {
    const rateInfo = sampleLoan.refiToday[rateType]
    const loans = [sampleLoan]

    return {
      apr: rateInfo.APR,
      rate: rateInfo.rate,
      savingsTotal: dictionary.refiSavingsTotal({ loans }, { rateType }),
      paymentSavings: dictionary.refiPaymentSavingsMonthly(
        { loans },
        { rateType }
      ),
      years:
        term === 'custom' ? dictionary.yearsLeft({ loans }, { rateType }) : term
    }
  })
)

const RefiPointContainer = compose(
  getContext(contextTypes),
  withProps(({ term }) => ({
    rateType: parseInt(term, 10) ? refiTodayKey(term) : term
  })),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  ),
  injectIntl
)

export default RefiPointContainer
